import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
// Function returns an instanceof of TypesenseInstantSearchAdapter
export function createTypesenseAdapter(config) {
    const defaultConfig = {
        server: {
            apiKey: "xyz",
            nodes: [
                {
                    host: "localhost",
                    port: "8108",
                    protocol: "http",
                },
            ],
        },
        additionalSearchParameters: {
            query_by: "name, sku, categories.label",
            highlight_full_fields: '',
        },
    };
    const finalConfig = Object.assign(Object.assign({}, defaultConfig), config);
    return new TypesenseInstantSearchAdapter(finalConfig);
}
